export interface UsernameFormState {
  readonly values: {
    readonly username: string;
    readonly isUsernamePrivate: boolean;
  };
  readonly touched: {
    readonly username: boolean;
    readonly isUsernamePrivate: boolean;
  };
  readonly isSubmitting: boolean;
  readonly error: string;
}

export const INITIAL_STATE: UsernameFormState = {
  values: {
    username: '',
    isUsernamePrivate: false,
  },
  touched: {
    username: false,
    isUsernamePrivate: false,
  },
  isSubmitting: false,
  error: '',
};
